module.exports = __webpack_public_path__ + "assets/img/users.aec4d406.png";